import React from 'react';
import createSvgIcon from './createSvgIcon';

const Icon = createSvgIcon(
  <>
    <circle cx="15" cy="15" r="15" fill="#67E1DE" />
    <circle cx="28.5" cy="16.5" r="7.5" fill="#9227FF" fillOpacity="0.75" />
  </>,
  'Creative',
);

export const Creative = (props: any) => <Icon viewBox="0 0 36 30" {...props} />;

export const Creative1 = () => (
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7.33333" cy="8.00033" r="7.33333" fill="#69E1DC" />
    <circle cx="14.3337" cy="8.33366" r="3.66667" fill="#9A5EF6" />
  </svg>
);
